// Statiske data og fallbacks til BRDR. LORENZEN. SKÆRBÆK ApS

export const companyInfo = {
  name: "BRDR. LORENZEN. SKÆRBÆK ApS",
  cvr: "10081483",
  address: "Ribevej 26",
  zipCity: "6780 Skærbæk",
  phone: "74751417",
  phoneFormatted: "74 75 14 17",
  email: "jf@blbiler.dk",
  mapUrl: "https://g.page/brdrlorenzen",
  openingHours: [
    { days: "Mandag - Torsdag", hours: "07:00 - 16:00" },
    { days: "Fredag", hours: "07:00 - 12:00" },
    { days: "Lørdag - Søndag", hours: "Lukket" }
  ]
};

export const staffMembers = [
  {
    name: "Jens Frisk",
    role: "Indehaver",
    image: "https://assets.auxodev.dk/assets/845935e5-3993-406d-896b-e0a4423b6917/d4d0c767-bb9a-408b-b1e7-28c146153cf1.jpg",
    description: "Siden 1/5 2022 indehaver og leder. Jens kom i lære hos Brdr. Lorenzen 1. jan. 2007. Efter endt læretid har Jens bl.a. arbejdet i 10 år hos en Fiat/Alfa, Renault, Peugeot og Citroen forhandler. Han har deltaget i alle relevante kurser indenfor benzin, diesel, hybrid og el køretøjer, og er derfor godt klædt på til fremtiden. Jens er en meget dygtig håndværker, med stor indsigt i alt omkring biler."
  },
  {
    name: "Sune Caspersen",
    role: "Mekanikersvend",
    image: "https://assets.auxodev.dk/assets/845935e5-3993-406d-896b-e0a4423b6917/5906f60a-0c69-47ae-b00e-860c70dfafb2.jpg",
    description: "Sune er udlært og har i 10 år arbejdet hos en Skoda, Huyndai, Suzuki og Nissan forhandler. Har siden okt. 2020 været ansat hos Brdr. Lorenzen. Sune har deltaget i alle relevante kurser indenfor benzin, diesel, hybrid og el biler. Sune is en meget dygtig, omhyggelig mekaniker. Ansvars- og tillidsfuld."
  },
  {
    name: "Ny mand",
    role: "Tekniker",
    image: "https://assets.auxodev.dk/assets/845935e5-3993-406d-896b-e0a4423b6917/02dd8286-173e-4336-b5ff-90be473ddaef.jpg",
    description: "Startede 1/4 2025"
  },
  {
    name: "Mads",
    role: "Lærling",
    image: "https://assets.auxodev.dk/assets/845935e5-3993-406d-896b-e0a4423b6917/4a474fc5-9e74-47e7-81d6-39eea8ecdc95.jpg",
    description: "Er startet i lære d. 1/3-24"
  }
];

export const reviews = [
  {
    id: 1,
    name: "Thomas Hansen",
    location: "Skærbæk",
    rating: 5,
    text: "Super professionel betjening og lynhurtig dækskifte. Kan varmt anbefales!"
  },
  {
    id: 2,
    name: "Mette Nielsen",
    location: "Tønder",
    rating: 5,
    text: "Altid ærlig service og gennemsigtige priser. Her føler man sig tryg som kunde."
  },
  {
    id: 3,
    name: "Lars Sørensen",
    location: "Ribe",
    rating: 5,
    text: "Fantastisk pladeværksted! De udbedrede min forsikringsskade perfekt og stillede en gratis lånebil til rådighed."
  },
  {
    id: 4,
    name: "Christian Jensen",
    location: "Skærbæk",
    rating: 5,
    text: "Jens og hans team har styr på sagerne. Hurtig fejlsøgning og reparation til en fair pris."
  },
  {
    id: 5,
    name: "Henrik Poulsen",
    location: "Bredebro",
    rating: 5,
    text: "Yderst kompetent værksted. De fandt hurtigt fejlen på min automatgearkasse og skyllede den, så den nu skifter som ny."
  }
];

export const partnerLogos = [
  { name: "DBR", src: "https://assets.auxodev.dk/assets/845935e5-3993-406d-896b-e0a4423b6917/7f9afc52-bfc7-4845-b8b0-b9373c60d044.svg" },
  { name: "Bilgaranti", src: "https://assets.auxodev.dk/assets/845935e5-3993-406d-896b-e0a4423b6917/33f5606f-9358-44c8-b25a-6f1f5a9cf5bd.svg" },
  { name: "Seek4cars", src: "https://assets.auxodev.dk/assets/845935e5-3993-406d-896b-e0a4423b6917/d6c6b344-3fd5-4d3c-9232-0efb43a4be15.svg" },
  { name: "Accept Auto", src: "https://assets.auxodev.dk/assets/845935e5-3993-406d-896b-e0a4423b6917/b76b90dd-42f2-424c-970f-aed6a1ac5807.svg" }
];
